import { useEffect } from 'react'
import { useFonts } from '@/providers/font'

/**
 * Keeps the Font Family picker in step with spread and selection changes: closes it when the
 * spread changes, and fetches the full catalog when the shown family isn't loaded yet.
 */
export function useFontPickerSync(
  spreadId: string | undefined,
  fontFamilyIdValue: string,
  setFontFamilySelectOpen: (open: boolean) => void
) {
  const { getFamilyById, loadFullCatalog } = useFonts()

  useEffect(() => {
    setFontFamilySelectOpen(false)
  }, [spreadId, setFontFamilySelectOpen])

  useEffect(() => {
    const id = Number(fontFamilyIdValue)

    if (!fontFamilyIdValue || !Number.isFinite(id)) return
    if (getFamilyById(id)) return

    loadFullCatalog()
  }, [fontFamilyIdValue, getFamilyById, loadFullCatalog])
}
